import { SamSourceSpec } from "userful-chronos-app-common-js/dist/models/sam/SAMSourceSpec";

export const AWS_SOURCE_SPECS: SamSourceSpec[] = [
    {
        header: {
            id: {
                value: "Web_Browser",
                name: "Web Browser",
            },
            name: "Web Browser",
            userVisible: true,
            directSource: false,
            sharable: true,
            requiresLiveData: false,
            recommendNVidia: false,
            requiresNVidia: false,
            outputType: "VIDEO_AND_AUDIO",
            controlMode: "NONE",
        },
        params: [
            {
                id: {
                    value: "Web_Browser_Icon",
                },
                type: "IMAGE_SELECT",
                name: "Icon",
                index: 0,
                required: true,
                help: "The following icons are retrieved from /usr/share/userful-plugin-webbrowser/icons",
                default: "/usr/share/userful-plugin-webbrowser/icons/webbrowser.png",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "path",
                        value: "/html/icons/userful-plugin-webbrowser",
                    },
                ],
                options: [
                    "/usr/share/userful-plugin-webbrowser/icons/chrome.png",
                    "/usr/share/userful-plugin-webbrowser/icons/cloud-icon.png",
                    "/usr/share/userful-plugin-webbrowser/icons/edge.png",
                    "/usr/share/userful-plugin-webbrowser/icons/firefox.png",
                    "/usr/share/userful-plugin-webbrowser/icons/google.png",
                    "/usr/share/userful-plugin-webbrowser/icons/settings.png",
                    "/usr/share/userful-plugin-webbrowser/icons/system-logo.png",
                    "/usr/share/userful-plugin-webbrowser/icons/webbrowser.png",
                ],
                optionValues: [
                    "/usr/share/userful-plugin-webbrowser/icons/chrome.png",
                    "/usr/share/userful-plugin-webbrowser/icons/cloud-icon.png",
                    "/usr/share/userful-plugin-webbrowser/icons/edge.png",
                    "/usr/share/userful-plugin-webbrowser/icons/firefox.png",
                    "/usr/share/userful-plugin-webbrowser/icons/google.png",
                    "/usr/share/userful-plugin-webbrowser/icons/settings.png",
                    "/usr/share/userful-plugin-webbrowser/icons/system-logo.png",
                    "/usr/share/userful-plugin-webbrowser/icons/webbrowser.png",
                ],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Web_Browser_URL",
                },
                type: "TEXT",
                name: "URL",
                index: 2,
                required: true,
                help: "",
                default: "http://www.userful.com/welcome",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "size",
                        value: "40",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Web_Browser_help",
                },
                type: "HELP",
                name: "",
                index: 7,
                required: false,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "url",
                        value: "https://support.userful.com/Docs/Mapping/Web_Browser",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
        ],
        assetSpecs: [],
    },
    {
        header: {
            id: {
                value: "Signage_Player",
                name: "Signage Player",
            },
            name: "Signage Player",
            userVisible: true,
            directSource: true,
            sharable: true,
            requiresLiveData: false,
            recommendNVidia: false,
            requiresNVidia: false,
            outputType: "VIDEO_AND_AUDIO",
            controlMode: "NONE",
        },
        params: [
            {
                id: {
                    value: "Signage_Player_Icon",
                },
                type: "IMAGE_SELECT",
                name: "Icon",
                index: 0,
                required: true,
                help: "The following icons are retrieved from /usr/share/userful-plugin-signage-player/icons",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "path",
                        value: "/html/icons/userful-plugin-signage-player",
                    },
                ],
                options: ["/usr/share/userful-plugin-signage-player/icons/MediaPlayer.png"],
                optionValues: ["/usr/share/userful-plugin-signage-player/icons/MediaPlayer.png"],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Signage_Player_Slideshow_interval",
                },
                type: "NUMBER",
                name: "Slideshow interval",
                index: 2,
                required: false,
                help: "",
                default: "30",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "size",
                        value: "5",
                    },
                    {
                        name: "maximum",
                        value: "300",
                    },
                    {
                        name: "minimum",
                        value: "5",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Signage_Player_help",
                },
                type: "HELP",
                name: "",
                index: 4,
                required: false,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "url",
                        value: "http://support.userful.com/Docs/Station_Mapping/Signage_Player",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
        ],
        assetSpecs: [
            {
                sourceParamName: "Playlist",
                cardinality: "MANY",
                required: true,
                sourceAssetType: "MEDIA_FILE",
                paramFormat: "MEDIA_FILE_LIST",
            },
        ],
    },
    {
        header: {
            id: {
                value: "Emerald_Signage",
                name: "Emerald Signage",
            },
            name: "Emerald Signage",
            userVisible: true,
            directSource: false,
            sharable: true,
            requiresLiveData: false,
            recommendNVidia: false,
            requiresNVidia: false,
            outputType: "VIDEO_AND_AUDIO",
            controlMode: "NONE",
        },
        params: [
            {
                id: {
                    value: "Emerald_Signage_Icon",
                },
                type: "IMAGE_SELECT",
                name: "Icon",
                index: 0,
                required: true,
                help: "The following icons are retrieved from /usr/share/userful-plugin-emerald-signage/icons",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "path",
                        value: "/html/icons/userful-plugin-emerald-signage",
                    },
                ],
                options: [
                    "/usr/share/userful-plugin-emerald-signage/icons/engage-signage.png",
                    "/usr/share/userful-plugin-emerald-signage/icons/system-logo.png",
                ],
                optionValues: [
                    "/usr/share/userful-plugin-emerald-signage/icons/engage-signage.png",
                    "/usr/share/userful-plugin-emerald-signage/icons/system-logo.png",
                ],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Emerald_Signage_Engage_Manual_Setup",
                },
                type: "INSTRUCTION",
                name: "Engage Manual Setup",
                index: 1,
                required: false,
                help: "",
                default:
                    'Engage Signage requires you to assign the source to a Destination to display a pairing code then <a href="/engage/?defaultcontent=cmsTool" target="_blank">login to your Engage account</a> to link the session.',
                requiresLogicalSeat: false,
                additionalParams: [],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Emerald_Signage_help",
                },
                type: "HELP",
                name: "",
                index: 6,
                required: false,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "url",
                        value: "https://support.userful.com/Docs/Mapping/Engage",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
        ],
        assetSpecs: [],
    },
    {
        header: {
            id: {
                value: "Splunk",
                name: "Splunk",
            },
            name: "Splunk",
            userVisible: true,
            directSource: false,
            sharable: true,
            requiresLiveData: false,
            recommendNVidia: false,
            requiresNVidia: false,
            outputType: "VIDEO_AND_AUDIO",
            controlMode: "NONE",
        },
        params: [
            {
                id: {
                    value: "Splunk_Icon",
                },
                type: "IMAGE_SELECT",
                name: "Icon",
                index: 0,
                required: true,
                help: "The following icons are retrieved from /usr/share/userful-plugin-splunk/icons",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "path",
                        value: "/html/icons/userful-plugin-splunk",
                    },
                ],
                options: [
                    "/usr/share/userful-plugin-splunk/icons/splunk.png",
                    "/usr/share/userful-plugin-splunk/icons/system-logo.png",
                ],
                optionValues: [
                    "/usr/share/userful-plugin-splunk/icons/splunk.png",
                    "/usr/share/userful-plugin-splunk/icons/system-logo.png",
                ],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Splunk_Passport",
                },
                type: "HIDDEN",
                name: "Splunk passport",
                index: 1,
                required: true,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Splunk_Dashboard",
                },
                type: "HIDDEN",
                name: "Splunk dashboard",
                index: 2,
                required: true,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Splunk_Reload_Interval",
                },
                type: "HIDDEN",
                name: "Reload Interval (min)",
                index: 3,
                required: false,
                help: "",
                default: "0",
                requiresLogicalSeat: false,
                additionalParams: [],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
            {
                id: {
                    value: "Splunk_help",
                },
                type: "HELP",
                name: "",
                index: 6,
                required: false,
                help: "",
                default: "",
                requiresLogicalSeat: false,
                additionalParams: [
                    {
                        name: "url",
                        value: "https://docs.userful.com/userful-infinity/12.10/integrations/splunk-enterprise-security",
                    },
                ],
                options: [],
                optionValues: [],
                optionIcons: [],
                multiOptions: [],
            },
        ],
        assetSpecs: [],
    },
];
